import { render, staticRenderFns } from "./bottleBox.vue?vue&type=template&id=73d79882&scoped=true"
import script from "./bottleBox.vue?vue&type=script&lang=js"
export * from "./bottleBox.vue?vue&type=script&lang=js"
import style0 from "./bottleBox.vue?vue&type=style&index=0&id=73d79882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d79882",
  null
  
)

export default component.exports